<ng-container *ngIf="page_summary_data_loaded">
    <div class="page-summary-section">
        <div class="each-page-summary-section">
            <p class="each-page-summary-section-count" style="margin: 14px 0;">Agent 3</p>
            <p class="each-page-summary-section-label"></p>
        </div>
        <div class="each-page-summary-section" *ngFor="let summary of page_summary_data">
            <p class="each-page-summary-section-count">{{ commonService.abbreviateNumber(summary.value) }}</p>
            <p class="each-page-summary-section-label">{{summary.name}}</p>
        </div>
    </div>
</ng-container>
